if (import.meta.hot) {
  import.meta.hot.on("vite:beforeFullReload", () => {
    throw "(skipping full reload)";
  });
}

import "#src/utils/logrocket.ts";
import "#src/utils/sentry.ts";

import "#src/styles/global.css";
import "#src/styles/tailwind.css";
import "#src/styles/text.css";

import { applyGoogleTranslateFix } from "#src/utils/googleTranslateFix.ts";
import { createRoot } from "react-dom/client";
import App from "./App";

applyGoogleTranslateFix();

const container = document.getElementById("app");

if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
